import {useEffect, useMemo, useState} from "react";
// import {socket} from "../socket/socket";
import moment from "moment";
import useSocketMessages from "../socket/useSocket";

export const useOfferMessages = ({socket, selectedConversation}) => {
  const {messageRemoteList, addMessage, connectSocket} =
    useSocketMessages({
      socket,
      selectedConversation,
    });

  const [messageLoading, setMessageLoading] = useState(false);

  // const queryClient = useQueryClient();

  useEffect(() => {
    if (selectedConversation?.id) {
      connectSocket();
      setMessageLoading(true);
      // socket.emit("join_room", String(selectedConversation?.id));
    }

    return () => {
      // socket.emit("leave_room", String(selectedConversation?.id));
      setMessageLoading(false);
    };
  }, [selectedConversation?.id, socket, connectSocket]);

  const messageLocalList = useMemo(
    () =>
      messageRemoteList.length
        ? messageRemoteList
            .filter((el) => Number(el?.chatRoomId) === Number(selectedConversation?.id))
            ?.sort((a, b) => {
              const date1 = moment(a.createdAt);
              const date2 = moment(b.createdAt);

              return date1.diff(date2);
            })
        : [],
    [messageRemoteList, selectedConversation?.id],
  );

  useEffect(() => {
    setMessageLoading(false);
  }, [messageRemoteList]);

  return {
    messageLocalList,
    addMessage,
    connectSocket,
    messageLoading,
    setMessageLoading,
  };
};
